import { t } from "../../../services/utils";
import React from "react";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
class PhotoView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let size = PhotoView.getPhotoSize(this.props.photo, this.props.isModal);
    let styles = {
      container: {
        backgroundColor: "white",
        padding: 10,
        paddingLeft: 16,
        paddingRight: 16,
        display: "flex",
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
        paddingBottom: this.props.forWorkout ? 25 : 5,
      },
      photo: {
        height: size.height,
        width: size.width,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 4,
      },
    };
    let photoUrl = "";
    if (this.props.photo.url) {
      photoUrl = this.props.photo.url;
    } else {
      photoUrl = `/users_photos/${this.props.photo.id}`;
      if (process.env.NODE_ENV === "stage") {
        photoUrl = process.env.ROOT_URL + photoUrl;
      }
    }
    return (
      <div style={styles.container} data-testid="story-photo">
        <img style={styles.photo} src={photoUrl} />
      </div>
    );
  };
  static getPhotoSize(photo, isModal) {
    let storyWidth = isModal ? 640 : STORY_VIEW_WIDTH;
    let containerWidth = storyWidth - 70;
    let aspectRatio = photo.w / photo.h;
    if (aspectRatio >= 1) {
      let w = containerWidth;
      return {
        width: w,
        height: w / aspectRatio,
      };
    } else {
      if (photo.h > containerWidth) {
        let h = containerWidth;
        return {
          width: h * aspectRatio,
          height: h,
        };
      } else {
        return {
          width: photo.h * aspectRatio,
          height: photo.h,
        };
      }
    }
  }
  static getHeight(props) {
    return PhotoView.getPhotoSize(props.photo, props.isModal).height + 15;
  }
}
export default PhotoView;
